import { GET_NEWEST_COMMENTS } from '../../constants/ActionTypes';

export const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: [],
};

export default function newestcomments(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_NEWEST_COMMENTS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_NEWEST_COMMENTS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action.result,
      };
    case `${GET_NEWEST_COMMENTS}_FAIL`:
      return {
        ...state,
        error: 'failed',
        loaded: false,
        loading: false,
      };

    default:
      return state;
  }
}
